// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"c8c206e8","75":"ee356972","116":"12477bb5","453":"8ef05367","455":"325833a6","977":"ca10cd61"}[chunkId] + ".chunk.js";
};